<script setup lang="ts">
const background = computed(() => {
  return `linear-gradient(90deg, rgba(26, 23, 25, 1) 50%, rgba(35, 37, 49, 0) 50%), url(${useCdnUrl()}/assets/creative-services/dotted-background.png)`;
});
</script>

<template>
  <div class="home-section about-block">
    <div class="container">
      <h2>Immersive Features for <b>Virtual Production</b></h2>

      <div class="body">
        <ul>
          <li>
            <div class="icon">
              <img
                :src="`${useCdnUrl()}/assets/solutions/virtual-production/icon-presenter-controls.png`"
                style="padding-left: 10px"
              />
            </div>
            <p>Presenter controls for managing the screen from an iPhone or iPad</p>
          </li>

          <li>
            <div class="icon">
              <img
                :src="`${useCdnUrl()}/assets/solutions/virtual-production/icon-companion-apps.png`"
              />
            </div>
            <p>Companion apps<br />on mobile phones</p>
          </li>

          <li>
            <div class="icon">
              <img :src="`${useCdnUrl()}/assets/solutions/virtual-production/icon-audience.png`" />
            </div>
            <p>
              Real-time audience reactions (emojis, motion effects, AI-driven sentiment analysis)
            </p>
          </li>

          <li>
            <div class="icon">
              <img
                :src="`${useCdnUrl()}/assets/solutions/virtual-production/icon-video-conference.png`"
              />
            </div>
            <p>Videoconferencing for<br />“teleporting” remote presenters</p>
          </li>

          <!--  second row -->
          <li>
            <div class="icon">
              <img
                :src="`${useCdnUrl()}/assets/solutions/virtual-production/icon-interactive.png`"
              />
            </div>
            <p>Interactive audience polling<br />with real-time on-screen<br />graphs and charts</p>
          </li>

          <li>
            <div class="icon">
              <img
                :src="`${useCdnUrl()}/assets/solutions/virtual-production/icon-communities.png`"
              />
            </div>
            <p>Smart communities made up<br />of local and remote participants</p>
          </li>

          <li>
            <div class="icon">
              <img :src="`${useCdnUrl()}/assets/solutions/virtual-production/icon-selfies.png`" />
            </div>
            <p>
              Selfie walls, digital graffiti,<br />games, scrolling on-screen<br />message boards
            </p>
          </li>

          <li>
            <div class="icon">
              <img
                :src="`${useCdnUrl()}/assets/solutions/virtual-production/icon-integration.png`"
              />
            </div>
            <p>Integration with MS Teams,<br />Zoom, Google Meet</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.about-block {
  background: v-bind(background);
  background-color: rgb(26, 23, 25);

  color: #fff;
  .container {
    h2 {
      font-weight: 200 !important;
    }
    .body {
      ul {
        align-items: flex-start;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 2rem;
        list-style-type: none;
        margin: 0;
        padding: 0;

        li {
          align-items: center;
          display: flex;
          flex: 20%;
          flex-direction: column;
          gap: 1rem;
          justify-content: center;
          text-align: center;
          .icon {
            align-items: center;
            background-color: white;
            border-radius: 50%;
            color: black;
            display: flex;
            height: 120px;
            justify-content: center;
            overflow: hidden;
            width: 120px;

            img {
              height: 70px;
              object-fit: contain;
              width: 100px;
            }
          }

          p {
            font-size: 1.8rem;
          }
        }
      }
    }

    .body-action {
      padding-top: 3rem;
      text-align: center;
    }
  }
}
</style>
